import type { IntlShape } from "react-intl";

import messages from "../../locales/messages";
import {
  DefaultTierDisplayName,
  SubscriptionPeriod,
  SubscriptionTier,
  SubscriptionTierDisplayNames,
  SubscriptionType,
} from "../../types";

export const getTierDisplayName = (tier: SubscriptionTier): string =>
  SubscriptionTierDisplayNames[tier] ?? DefaultTierDisplayName;

export const getPlanDisplayName = (
  type: SubscriptionType,
  subscriptionPeriod: SubscriptionPeriod,
  tier: SubscriptionTier,
  teamName: string | undefined,
  t: IntlShape["formatMessage"]
): string => {
  const tierName = tier ? getTierDisplayName(tier) : "";

  if (type === SubscriptionType.PaddleOneTime) {
    return t(
      subscriptionPeriod === SubscriptionPeriod.Yearly
        ? messages.TeamSubscriptionPage.PlanPaddleOneTimeYearly
        : messages.TeamSubscriptionPage.PlanPaddleOneTimeMonthly,
      { tierName }
    );
  }

  if (
    type === SubscriptionType.Paddle ||
    type === SubscriptionType.Chargebee ||
    type === SubscriptionType.AppStore
  ) {
    return t(
      subscriptionPeriod === SubscriptionPeriod.Yearly
        ? messages.TeamSubscriptionPage.PlanBilledAnnually
        : messages.TeamSubscriptionPage.PlanBilledMonthly,
      { tierName }
    );
  }

  switch (type) {
    case "edu":
      return t(messages.TeamSubscriptionPage.PlanEdu);
    case "gift":
      return t(messages.TeamSubscriptionPage.PlanGift);
    case "team":
      return t(messages.TeamSubscriptionPage.PlanTeam, { teamName });
  }

  return "N/A";
};

export const getSourceDisplayName = (source: string, t: IntlShape["formatMessage"]): string => {
  switch (source) {
    case "appstore":
      return "App Store";
    case "team":
    case "paddle":
    case "paddle_one_time":
    case "chargebee":
      return t(messages.TeamSubscriptionPage.SourceShapr3dWebsite, { brand: "Shapr3D" });
    case "edu":
      return t(messages.TeamSubscriptionPage.SourceEdu);
    case "gift":
      return t(messages.TeamSubscriptionPage.SourceGift);
  }

  return "N/A";
};

export const formatExpirationDate = (expiration: string): string => {
  return new Date(expiration).toLocaleDateString("en-us", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};
